import BaseObjectStore from './base-object.store';

class FuelingPlanStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'fuelingPlan';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new FuelingPlanStore();
